const localization = {
  remainingCharacters: (remainder: number) => `Characters remaining: ${remainder}`,
}

export default localization
